export default __webpack_public_path__ + "static/media/relative-faux-book-pro.a7a6ab05.ttf";